(function () {
  var SECTION_SELECTOR = '.oddit-section-press';

  function initSection(section) {
    var track = section.querySelector('.oddit-section-press__track');
    if (!track) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.oddit-section-press__slide'));
    var dots = section.querySelectorAll('.oddit-section-press__dot');
    var totalReal = slides.length;
    if (totalReal === 0) return;

    /* ------------------------------------------------------------------
       Build inner wrapper with clones for infinite loop
       ------------------------------------------------------------------ */
    var inner = document.createElement('div');
    inner.className = 'oddit-section-press__track-inner';

    // Clone last few slides → prepend, clone first few slides → append
    var cloneCount = Math.min(3, totalReal);
    var prependClones = [];
    var appendClones = [];

    for (var i = 0; i < cloneCount; i++) {
      var appendClone = slides[i].cloneNode(true);
      appendClone.setAttribute('aria-hidden', 'true');
      appendClone.classList.remove('oddit-section-press__slide--active');
      appendClone.classList.remove('oddit-reveal');
      appendClone.removeAttribute('data-slide-index');
      appendClones.push(appendClone);
    }
    for (var j = totalReal - cloneCount; j < totalReal; j++) {
      var prependClone = slides[j].cloneNode(true);
      prependClone.setAttribute('aria-hidden', 'true');
      prependClone.classList.remove('oddit-section-press__slide--active');
      prependClone.classList.remove('oddit-reveal');
      prependClone.removeAttribute('data-slide-index');
      prependClones.push(prependClone);
    }

    // Build inner: clones-before + real slides + clones-after
    prependClones.forEach(function (c) { inner.appendChild(c); });
    slides.forEach(function (s) { inner.appendChild(s); });
    appendClones.forEach(function (c) { inner.appendChild(c); });

    track.innerHTML = '';
    track.appendChild(inner);

    var allSlides = Array.prototype.slice.call(inner.children);
    var currentIndex = cloneCount; // start on first real slide (index 0 in real = cloneCount in allSlides)

    /* ------------------------------------------------------------------
       Layout helpers
       ------------------------------------------------------------------ */
    function getSlideWidth() {
      return allSlides[0].getBoundingClientRect().width;
    }

    function getGap() {
      var style = window.getComputedStyle(inner);
      return parseFloat(style.gap) || 10;
    }

    function getOffset(index) {
      var slideW = getSlideWidth();
      var gap = getGap();
      var trackW = track.getBoundingClientRect().width;
      // Center the slide at `index` within the track
      return -((slideW + gap) * index - (trackW / 2 - slideW / 2));
    }

    function applyTransform(animate) {
      if (!animate) {
        inner.style.transition = 'none';
      } else {
        inner.style.transition = 'transform 0.5s ease';
      }
      inner.style.transform = 'translateX(' + getOffset(currentIndex) + 'px)';

      if (!animate) {
        // Force reflow to apply instant position before re-enabling transitions
        inner.offsetHeight; // eslint-disable-line no-unused-expressions
      }
    }

    /* ------------------------------------------------------------------
       Active state
       ------------------------------------------------------------------ */
    function updateActive() {
      allSlides.forEach(function (s) {
        s.classList.remove('oddit-section-press__slide--active');
      });
      allSlides[currentIndex].classList.add('oddit-section-press__slide--active');

      // Also highlight neighbours that are clones of the active real slide
      var realIndex = getRealIndex();
      allSlides.forEach(function (s, i) {
        if (i !== currentIndex) {
          // Check if this clone represents the same real slide
          var ri = i - cloneCount;
          if (ri < 0) ri += totalReal;
          if (ri >= totalReal) ri -= totalReal;
          // Don't highlight clones — only the centered one
        }
      });

      updateDots(realIndex);
    }

    function getRealIndex() {
      return ((currentIndex - cloneCount) % totalReal + totalReal) % totalReal;
    }

    function updateDots(activeIndex) {
      dots.forEach(function (dot) {
        dot.classList.toggle(
          'oddit-section-press__dot--active',
          parseInt(dot.getAttribute('data-dot-index'), 10) === activeIndex
        );
      });
    }

    /* ------------------------------------------------------------------
       Navigate
       ------------------------------------------------------------------ */
    function goTo(index, animate) {
      currentIndex = index;
      applyTransform(animate !== false);
      updateActive();
    }

    function next() {
      goTo(currentIndex + 1, true);
    }

    function prev() {
      goTo(currentIndex - 1, true);
    }

    /* ------------------------------------------------------------------
       Handle clone-boundary jump (seamless wrap)
       ------------------------------------------------------------------ */
    inner.addEventListener('transitionend', function (e) {
      if (e.target !== inner) return;
      var jumped = false;

      if (currentIndex >= totalReal + cloneCount) {
        // Past last clone → jump to first real
        currentIndex = cloneCount;
        jumped = true;
      } else if (currentIndex < cloneCount) {
        // Before first clone → jump to last real
        currentIndex = totalReal + cloneCount - 1;
        jumped = true;
      }

      if (jumped) {
        applyTransform(false);
        updateActive();
      }
    });

    /* ------------------------------------------------------------------
       Initial position
       ------------------------------------------------------------------ */
    goTo(cloneCount, false);

    /* ------------------------------------------------------------------
       Dot click handlers
       ------------------------------------------------------------------ */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var realTarget = parseInt(dot.getAttribute('data-dot-index'), 10);
        var realCurrent = getRealIndex();
        var diff = realTarget - realCurrent;
        goTo(currentIndex + diff, true);
        resetAutoplay();
      });
    });

    /* ------------------------------------------------------------------
       Touch / swipe support
       ------------------------------------------------------------------ */
    var touchStartX = 0;
    var touchStartY = 0;
    var touchDeltaX = 0;
    var isSwiping = false;
    var startOffset = 0;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchDeltaX = 0;
      isSwiping = false;
      startOffset = getOffset(currentIndex);
      inner.style.transition = 'none';
      if (autoplayCtrl) autoplayCtrl.stop();
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;

      if (!isSwiping) {
        // Determine if horizontal or vertical swipe
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
          isSwiping = true;
        } else if (Math.abs(dy) > Math.abs(dx)) {
          return; // vertical scroll, bail
        }
      }

      if (isSwiping) {
        e.preventDefault();
        touchDeltaX = dx;
        inner.style.transform = 'translateX(' + (startOffset + touchDeltaX) + 'px)';
      }
    }, { passive: false });

    track.addEventListener('touchend', function () {
      if (isSwiping) {
        var threshold = getSlideWidth() * 0.2;
        if (touchDeltaX < -threshold) {
          next();
        } else if (touchDeltaX > threshold) {
          prev();
        } else {
          goTo(currentIndex, true);
        }
      }
      isSwiping = false;
      if (autoplayCtrl) {
        autoplayCtrl.resetTimer();
        autoplayCtrl.start();
      }
    }, { passive: true });

    /* ------------------------------------------------------------------
       Autoplay
       ------------------------------------------------------------------ */
    var autoplayCtrl = null;
    var autoplayEnabled = section.getAttribute('data-autoplay') === 'true';

    if (autoplayEnabled) {
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (!reducedMotion.matches) {
        var speedSeconds = parseInt(section.getAttribute('data-autoplay-speed'), 10) || 5;
        var intervalMs = speedSeconds * 1000;
        var rafId = null;
        var lastAdvance = performance.now();

        function tick(now) {
          if (now - lastAdvance >= intervalMs) {
            next();
            lastAdvance = now;
          }
          rafId = requestAnimationFrame(tick);
        }

        autoplayCtrl = {
          start: function () {
            if (rafId) return;
            lastAdvance = performance.now();
            rafId = requestAnimationFrame(tick);
          },
          stop: function () {
            cancelAnimationFrame(rafId);
            rafId = null;
          },
          resetTimer: function () {
            lastAdvance = performance.now();
          },
          destroy: function () {
            this.stop();
          }
        };

        document.addEventListener('visibilitychange', function () {
          if (reducedMotion.matches) return;
          document.hidden ? autoplayCtrl.stop() : autoplayCtrl.start();
        });

        track.addEventListener('mouseenter', function () { autoplayCtrl.stop(); });
        track.addEventListener('mouseleave', function () { autoplayCtrl.start(); });
        track.addEventListener('focusin', function () { autoplayCtrl.stop(); });
        track.addEventListener('focusout', function () { autoplayCtrl.start(); });

        reducedMotion.addEventListener('change', function (e) {
          e.matches ? autoplayCtrl.stop() : autoplayCtrl.start();
        });

        autoplayCtrl.start();
      }
    }

    function resetAutoplay() {
      if (autoplayCtrl) {
        autoplayCtrl.stop();
        autoplayCtrl.resetTimer();
        autoplayCtrl.start();
      }
    }

    /* ------------------------------------------------------------------
       Resize — recalculate position
       ------------------------------------------------------------------ */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        applyTransform(false);
      }, 100);
    });

    /* ------------------------------------------------------------------
       Store state for cleanup
       ------------------------------------------------------------------ */
    section._pressState = {
      autoplay: autoplayCtrl
    };
  }

  /* --------------------------------------------------------------------
     Cleanup
     -------------------------------------------------------------------- */
  function destroySection(section) {
    if (section._pressState) {
      if (section._pressState.autoplay) section._pressState.autoplay.destroy();
      delete section._pressState;
    }
  }

  /* --------------------------------------------------------------------
     Init
     -------------------------------------------------------------------- */
  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
